import React, { useState, useEffect } from 'react';
import './classes/TalkwithLynn.css';
import { configData } from "../config";
import { Helmet } from 'react-helmet';

const AdvancedForm = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    emailAgain: '',
    primary_phone: '',
    country: '',
    state: '',
    province: '',
    city: '',
    field_talk_with_dr_lashbrook: '',
    pageURL: window.location.href,
    showStateField: true,
    showProvinceField: false,
  });

  const [errors, setErrors] = useState({});
  const [statelist, setStateList] = useState({});
  const [countrieslist, setCountriesList] = useState({});

  const app_url = configData.APP_URL;

  useEffect(() => {
    retrieveStateList();
    retrieveCountriesList();
  }, []);

  async function retrieveStateList() {
    const statelistresponse = await fetch(app_url + 'smwwstates/getstatelist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const statelistdata = await statelistresponse.json();
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      statelist[key] = statelistdata.data.result[key];
    });
    setStateList(statelist);
    console.log(statelist);
  }

  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const countrieslistdata = await countrieslistresponse.json();
    const countrieslist = {};
    Object.keys(countrieslistdata.data.result).forEach(function(key) {
      countrieslist[key] = countrieslistdata.data.result[key];
    });
    setCountriesList(countrieslist);
    console.log(countrieslist);
  }

  const handleChange = event => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));

    if (event.target.name === 'country') {
      if (event.target.value === 'United States') {
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: false,
          showStateField: true,
        }));
      } else {
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: true,
          showStateField: false,
        }));
      }
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.first_name) tempErrors.first_name = 'First Name is required';
    if (!formData.last_name) tempErrors.last_name = 'Last Name is required';
    if (!formData.email) tempErrors.email = 'Email is required';
    if (!formData.emailAgain) tempErrors.emailAgain = 'Email confirmation is required';
    if (formData.email !== formData.emailAgain) tempErrors.emailAgain = 'Emails do not match';
    if (!formData.primary_phone) tempErrors.primary_phone = 'Phone Number is required';
    if (!formData.country) tempErrors.country = 'Country is required';
    if (formData.country === "United States") {
      if (!formData.state) {
        tempErrors.state = 'State / Province is required';
      }
    }
    if (!formData.field_talk_with_dr_lashbrook) tempErrors.field_talk_with_dr_lashbrook = 'Comments or Questions are required';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (validate()) {
      const postData = formData;
      const response = await fetch(app_url + 'talkwithlynn/application', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.data.result === "user_created") {
        alert("Form submitted");
      }
    }
  };

  return (
    <div className="talk-form-container">
      <Helmet><title>Talk With Dr. Lashbrook | Sports Management Worldwide</title></Helmet>

        <h1>Talk With Dr. Lynn Lashbrook</h1>
        <div className="paragraph-image-container">
          <div className='opening-paragraph'>
            <p>With over 50 years of experience in the sports industry, in roles ranging from NFL 
              agent to NCAA Athletic Director, Dr. Lynn Lashbrook has seen it all, and he’s willing
              to share his career advice and knowledge one-on-one with you!</p>
            <ul className='bullet-point'>
              <li>Looking for a sports business edge?</li>
              <li>Seeking to re-career?</li>
              <li>Dream of being a sports agent?</li>
              <li>Considering your Masters? Doctorate?</li>
              <li>Want to work in college athletics or the pros but don't know where to start?</li>
              <li>Currently work in sports and want to move up?</li>
            </ul>
            <p>Dr. Lashbrook is ready and willing to be your trusted advisor <span className='guidance'>whatever guidance you need in sports!</span>
              When Mike Matheny was fired as manager of the St. Louis Cardinals he spoke to Dr. Lashbrook, they 
              developed a plan together and one year later he was managing the Kansas City Royals.</p>
            <p>Dr. Lashbrook can help you too!</p> 
            <p>Fill out the form below and <u>he will call you directly</u> to discuss privately and confidentially your sports career questions.</p>
          </div> 
          <img src={`${process.env.PUBLIC_URL}/images/lynn_pic.png`} alt="lynn" className="paragraph-image" />
        </div>

        <div className="form-image-container">
          <form onSubmit={handleSubmit} className='talk-form-left'>
            <div className='talk-form-heading'>
              <p><strong>SPORTS JOBS START WITH SMWW</strong> <br />
                <em>(Please state your specific interest, question, or goal)</em>
              </p>
            </div>
            <div className='talk-fields'>
              <label>First Name <span className="form-required" title="This field is required.">*</span></label>
              <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
              {errors.first_name && <span>{errors.first_name}</span>}
            </div>
            <div className='talk-fields'>
              <label>Last Name <span className="form-required" title="This field is required.">*</span></label>
              <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
              {errors.last_name && <span>{errors.last_name}</span>}
            </div>
            <div className='talk-fields'>
              <label>Email <span className="form-required" title="This field is required.">*</span></label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} />
              {errors.email && <span>{errors.email}</span>}
            </div>
            <div className='talk-fields'>
              <label>Email, again <span className="form-required" title="This field is required.">*</span></label>
              <input type="email" name="emailAgain" value={formData.emailAgain} onChange={handleChange} />
              {errors.emailAgain && <span>{errors.emailAgain}</span>}
            </div>
            <div className='talk-fields'>
              <label>Phone Number <span className="form-required" title="This field is required.">*</span></label>
              <input type="tel" name="primary_phone" value={formData.primary_phone} onChange={handleChange} />
              {errors.primary_phone && <span>{errors.primary_phone}</span>}
            </div>
            <div className='talk-fields'>
              <label>Country <span className="form-required" title="This field is required.">*</span></label>
              <select className='smww-appn' id="country" name="country" value={formData.country} onChange={handleChange}>
                <option value="">Select Country</option>
                {Object.keys(countrieslist).map(item => {
                  return <option key={countrieslist[item].name} value={countrieslist[item].name}>{countrieslist[item].name}</option>
                })}
              </select>
              {errors.country && <span>{errors.country}</span>}
            </div>
            <div className='talk-fields'>
              {formData.showStateField && (
                <>
                  <label>State / Province <span className="form-required" title="This field is required.">*</span></label>
                  <select id="state" name="state" value={formData.state} onChange={handleChange}>
                    <option value="">Select State</option>
                    {Object.keys(statelist).map(state => {
                      return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>;
                    })}
                  </select>
                </>
              )}
              {formData.showProvinceField && (
                <>
                  <label>State / Province <span className="form-required" title="This field is required.">*</span></label>
                  <input type="text" id="province" name="province" value={formData.province} onChange={handleChange} />
                </>
              )}
              {errors.state && <span>{errors.state}</span>}
            </div>
            <div className='talk-fields'>
              <label>City</label>
              <input type="text" name="city" value={formData.city} onChange={handleChange} />
            </div>
            <div className='talk-fields'>
              <label>Comments or Questions <span className="form-required" title="This field is required.">*</span></label>
              <textarea name="field_talk_with_dr_lashbrook" value={formData.field_talk_with_dr_lashbrook} onChange={handleChange}></textarea>
              {errors.field_talk_with_dr_lashbrook && <span>{errors.field_talk_with_dr_lashbrook}</span>}
              <input type="hidden" name="pageURL" id="pageURL" value={formData.pageURL} onChange={handleChange} />
            </div>
            <button className='talk-with-lynn-btnn' type="submit">LET'S CHAT</button>
          </form>
          <div className='form-right-image'>
            <img src={`${process.env.PUBLIC_URL}/images/talk_with_dr_lashbrook.png`} alt="talk-with-lynn" className="form-bigimage-right" />
          </div>
        </div>
    </div>
  );
};

export default AdvancedForm;
